<template lang="pug">
div
    .text-right(v-if="!hasFinalized && !isDeclined")
        button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.red.m-r-sm.pull-left(
            type="button",
            :disabled="isLoading",
            @click="rejectRequest",
            v-if="canApprove"
        )
            v-loading(loader="reject-stock-request") Decline

        button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
            type="button",
            :disabled="isLoading",
            @click="cancel",
        ) Cancel

        button.md-btn.md-raised.m-b-sm.w-xs.green.m-r-sm(
            type="button",
            :disabled="isLoading",
            @click="saveChanges('save')",
            v-if="!hasFinalized && (canApprove || canUpdate)"
        )
            v-loading(loader="save-stock-request") Save

        button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green.m-r-sm(
            type="button",
            :disabled="isLoading",
            @click="approveRequest",
            v-if="canApprove"
        )
            v-loading(loader="approve-stock-request") Approve Request

        button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green.m-r-sm(
            type="button",
            :disabled="isLoading",
            @click="receiveStocks",
            v-if="canUpdate && isApproved"
        )
            v-loading(loader="receive-stock-request") Mark as Received

        button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green.m-r-sm(
            type="button",
            :disabled="isLoading",
            @click="saveChanges('send', statuses.REQUESTED)",
            v-if="isOpen"
        )
            v-loading(loader="send-stock-request") Send Request

    reject-form(ref="rejectForm")
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import stockRequestMixin from './stock-request-mixin';
import rejectForm from './stock-request-edit-reject';

export default {
    inject: ['$validator'],

    components: { rejectForm },

    mixins: [stockRequestMixin],

    computed: {
        ...mapGetters('stockRequest', ['request_to_outlet']),
    },

    methods: {
        ...mapActions('stockRequest', [
            'updateStockRequest',
            'setStockRequestAttr',
        ]),

        cancel() {
            this.$router.push('/');
        },

        async saveChanges(action, status = null) {
            if (
                !this.validateStockExists() &&
                status == this.statuses.REQUESTED
            )
                return;

            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updateStockRequest({ action, status });
                let text = 'Stock request has successfully saved';

                if (status == this.statuses.REQUESTED) {
                    text = 'Stock request has successfully sent';
                }

                this.swal({ text });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async approveRequest() {
            if (!this.validateStockExists()) return;

            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.swalAjaxConfirmation({
                    title: 'Approve Requested Stocks?',
                    type: 'warning',
                    text:
                        'This will deduct stock quantity from requested outlet',
                    preConfirm: () => {
                        const action = 'approve';
                        const status = this.statuses.APPROVED;
                        return this.updateStockRequest({ action, status });
                    },
                    onSuccess: () => {
                        this.swal({
                            text: 'Stock request has successfully approved',
                        });
                    },
                });
            } catch (e) {
                if (e !== 'cancel' && e !== 'esc') this.swalError({ text: e });
            }
        },

        async receiveStocks() {
            if (!this.validateStockExists()) return;

            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.swalAjaxConfirmation({
                    title: 'Mark as Received?',
                    type: 'warning',
                    text: 'Add all received stocks in destination outlet ?',
                    preConfirm: () => {
                        const action = 'receive';
                        const status = this.statuses.RECEIVED;
                        return this.updateStockRequest({ action, status });
                    },
                    onSuccess: () => {
                        this.swal({
                            text:
                                'Stock request has successfully mark as received',
                        });
                    },
                });
            } catch (e) {
                if (e !== 'cancel' && e !== 'esc') this.swalError({ text: e });
            }
        },

        rejectRequest() {
            this.$refs.rejectForm.$emit('show');
        },

        validateStockExists() {
            if (!this.stockRequest.stocks.length) {
                this.swalWarning({ text: 'No stock added' });
                return false;
            }

            return true;
        },

        async validateForm() {
            const validate = await this.$validator.validate();

            if (!validate) {
                // focus on error input
                const elem = $('input:text.has-error');
                if (elem.length) {
                    elem[0].focus();
                }
            }

            return validate;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-edit-action.vue